import LoadingComponent from './loading.vue'

const Loading = {}
Loading.install = function (Vue) {
  const LoadingConstructor = Vue.extend(LoadingComponent)
  const instance = new LoadingConstructor({
    el: document.createElement('div')
  })
  instance.show = false
  const loading = {
    show () {
      instance.show = true
      document.body.appendChild(instance.$el)
    },
    hide () {
      instance.show = false
    }
  }
  if (!Vue.$loading) {
    Vue.$loading = loading
  }
  Vue.mixin({
    created () {
      this.$loading = Vue.$loading
    }
  })
}

export default Loading
